import axios from '@/utils/api';
import * as jwtDecode from 'jwt-decode';
import { KEYS, setItem } from '@/store/local/localStorage';
import { SET_USUARIO, CLEAR_USUARIO, SET_SENHA_STATUS } from '../mutation-types';

const state = {
  usuarioLogado: null,
};

const getters = {
  usuarioLogado: (state) => state.usuarioLogado,
};

const mutations = {
  [SET_USUARIO](state, payload) {
    state.usuarioLogado = payload;
  },

  [CLEAR_USUARIO](state) {
    state.usuarioLogado = null;
    setItem(KEYS.LOGIN.usuario, state.usuario);
  },
  
  [SET_SENHA_STATUS](state, payload) {
    state.senhaStatus = payload;
  }
};

const actions = {
  async getUsuario({ commit }) {
    const usuario = !!localStorage.getItem(KEYS.LOGIN.usuario) || !!localStorage.getItem(KEYS.LOGIN.jwt) ? await jwtDecode(localStorage.getItem(KEYS.LOGIN.jwt)) : null;

    commit('SET_USUARIO', usuario)
    return usuario
  },

  async isAutenticado() {
    return (
      !!localStorage.getItem(KEYS.LOGIN.usuario) ||
      !!localStorage.getItem(KEYS.LOGIN.jwt)
    );
  },

  async loginPortalSeguranca({ commit, dispatch }, { login, senha }) {
    const data = await axios({
      method: 'POST',
      url: `autenticacao/login`,
      data: {
        login,
        senha,
      },
    });
    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`);
  
    const usuario = await dispatch('getUsuario');
    commit('SET_USUARIO', usuario);
  },

  async buscarModulos({ dispatch }) {
    return await axios({
      method: 'get',
      url:
        'autenticacao/usuario/' +
        (await dispatch('getUsuario')).sub +
        '/modulos',
    });
  },

  async buscarPerfis({ dispatch }) {
    const usuario = await dispatch('getUsuario');
    return await axios({
      method: 'get',
      url:
        'autenticacao/usuario/' +
        usuario.sub +
        '/modulo/' +
        usuario.idModuloSelecionado +
        '/perfis',
    });
  },

  async selecionePerfil({ commit, dispatch }, { perfilId }) {
    const data = await axios({
      method: 'post',
      url:
        'autenticacao/modulo/' +
        (await dispatch('getUsuario')).idModuloSelecionado +
        '/perfil/' +
        perfilId,
    });
    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`);

    const usuario = await dispatch('getUsuario');
    commit('SET_USUARIO', usuario);
  },

  async selecioneModulo({ commit, dispatch }, { moduloId }) {
    const data = await axios({
      method: 'post',
      url: 'autenticacao/modulo/' + moduloId,
    });
    setItem(KEYS.LOGIN.jwt, `${data.tokenType} ${data.accessToken}`);

    const usuario = await dispatch('getUsuario');
    commit('SET_USUARIO', usuario);
  },

  async verificarSenha({ commit }, { login, senha }) {
    try {
      const response = await axios({
        method: 'POST',
        url: 'autenticacao/verificarSenha',
        data: {
          login,
          senha,
        },
      });
      commit('SET_SENHA_STATUS', response.data);
      return response;
    } catch (error) {
      console.error('Erro ao verificar a senha:', error);
      throw error; 
    }
  },

  async logout({ commit }) {
    commit('CLEAR_USUARIO');
    setItem(KEYS.LOGIN.jwt, null);
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
